import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './ReducerCombine';

const store = configureStore({
  reducer: rootReducer,
});

export default store;
